import script from "./ModalListUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalListUser.vue?vue&type=script&lang=ts&setup=true"

import "./ModalListUser.vue?vue&type=style&index=0&id=cedd6224&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cedd6224"]])

export default __exports__